import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { effects } from './effects/index';
import { metaReducers, reducerProvider, reducerToken } from './reducers/index';
import { SOLD_TO_FEATURE } from './sold-to-state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StateModule,
    StoreModule.forFeature(SOLD_TO_FEATURE, reducerToken, { metaReducers }),
    EffectsModule.forFeature(effects),
  ],
  providers: [reducerProvider],
})
export class SoldToStoreModule {}
